module.exports = __webpack_public_path__ + "static/media/header.205a4c8f.jpg";